module.exports = {
    "dismiss": `L\xf5peta`
};


//# sourceMappingURL=et-EE.main.js.map
